(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Add simple styles
    const style = document.createElement('style');
    style.textContent = `
    .modal-overlay { 
      display: none; 
      position: fixed; 
      top: 0; 
      left: 0; 
      width: 100%; 
      height: 100%; 
      background: rgba(0,0,0,0.5); 
      z-index: 9999; 
    }
    .modal-overlay.active { 
      display: flex; 
      justify-content: center; 
      align-items: center; 
    }
    .modal-content { 
      max-width: 90%; 
      max-height: 90%; 
      background: white; 
      border-radius: 8px; 
      overflow: hidden; 
    }
    .modal-header { 
      display: flex; 
      align-items: center; 
      padding: 15px 20px; 
      background: #f8f9fa; 
      border-bottom: 1px solid #ddd; 
      justify-content: center;
      position: relative;
    }
    .modal-title { 
      margin: 0; 
      font-size: 18px; 
      color: #333; 
      text-transform: capitalize;
    }
    .modal-close { 
      background: none; 
      border: none; 
      font-size: 24px; 
      cursor: pointer; 
      position: absolute;
      right: 20px;
    }
    .modal-body { 
      padding: 20px; 
    }
    #modal-image { 
      width: 100%; 
      height: auto; 
      max-height: 70vh; 
    }
    .modal-loader { 
      text-align: center; 
      padding: 50px; 
    }
    body.modal-open {
      overflow: hidden;
    }
    @media(max-width:768px){
     .modal-body {
          padding: 5px;
      }
    }
  `;
    document.head.appendChild(style);

    // Find all size chart links - supporting both HTML structures
    const sizeChartLinks = document.querySelectorAll('.size-chart a');

    if (sizeChartLinks.length > 0) {
      sizeChartLinks.forEach((link) => {
        if (!link.dataset.modalInitialized) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // Get title from different sources based on HTML structure
            let title = '';

            // Method 1: Get from link text content
            if (this.textContent && this.textContent.trim() !== '') {
              title = this.textContent.trim();
            }
            // Method 2: Get from title attribute (fallback)
            else if (this.getAttribute('title') && this.getAttribute('title').trim() !== '') {
              title = this.getAttribute('title').trim();
            }
            // Method 3: Get from parent section heading
            else {
              const parentSection = this.closest('.size-chart');
              if (parentSection) {
                const heading = parentSection.querySelector('.size-chart-title, .accordion__title, h2');
                if (heading) {
                  title = heading.textContent.trim();
                }
              }
            }

            // Default fallback
            if (!title) {
              title = 'Size Chart';
            }

            // Update modal title
            const modalTitle = document.querySelector('.modal-title');
            if (modalTitle) {
              modalTitle.textContent = title;
            }

            // Show modal
            const modal = document.getElementById('size-chart-modal');
            const image = document.getElementById('modal-image');
            const loader = document.querySelector('.modal-loader');

            if (modal && image) {
              modal.classList.add('active');
              document.body.classList.add('modal-open');

              if (loader) {
                loader.style.display = 'block';
                image.style.display = 'none';
              }

              // Load image
              image.onload = function () {
                if (loader) loader.style.display = 'none';
                image.style.display = 'block';
              };

              image.onerror = function () {
                if (loader) {
                  loader.innerHTML = 'Failed to load image';
                }
              };

              image.src = this.href;
            }
          });

          // Mark as initialized to prevent double binding
          link.dataset.modalInitialized = 'true';
        }
      });
    }

    // Close modal function
    function closeModal() {
      const modal = document.getElementById('size-chart-modal');
      if (modal) {
        modal.classList.remove('active');
        document.body.classList.remove('modal-open');

        // Clear image source
        const image = document.getElementById('modal-image');
        if (image) {
          image.src = '';
        }

        // Reset loader
        const loader = document.querySelector('.modal-loader');
        if (loader) {
          loader.innerHTML = 'Loading...';
          loader.style.display = 'none';
        }
      }
    }

    // Close modal events
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('modal-close') || e.target.classList.contains('modal-overlay')) {
        closeModal();
      }
    });

    // Close modal with Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const modal = document.getElementById('size-chart-modal');
        if (modal && modal.classList.contains('active')) {
          closeModal();
        }
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const sizeChart = document.querySelector('.size-chart-block');
    const shareButton = document.querySelector('.share-button.quick-add-hidden');
    const wrapper = document.createElement('div');
    wrapper.classList.add('size-share-wrapper');
    sizeChart.parentNode.insertBefore(wrapper, sizeChart);
    wrapper.appendChild(sizeChart);
    wrapper.appendChild(shareButton);
  });

  } catch(e) { console.error(e); }
})();
})();
